var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofenceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7885 40.1147L31.3842 23.5403C31.9146 22.6243 32.1797 22.1663 32.5257 22.0125C32.8274 21.8783 33.1719 21.8783 33.4737 22.0125C33.8197 22.1663 34.0848 22.6243 34.6152 23.5403L44.2109 40.1147C44.7431 41.034 45.0092 41.4937 44.9699 41.871C44.9356 42.2 44.7632 42.499 44.4956 42.6936C44.1888 42.9167 43.6577 42.9167 42.5954 42.9167H23.404C22.3417 42.9167 21.8106 42.9167 21.5038 42.6936C21.2362 42.499 21.0638 42.2 21.0295 41.871C20.9902 41.4937 21.2563 41.034 21.7885 40.1147Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceEmpty);
export default __webpack_public_path__ + "static/media/geofenceEmpty.5591e2392036c7a3ac952cf60d6be995.svg";
export { ForwardRef as ReactComponent };